import m from "../../geodata/es2015/vaticanLow";
window.am4geodata_vaticanLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/vaticanLow.js
// module id = null
// module chunks = 